module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-main",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [_c('section', {
    staticClass: "user-section"
  }, [_c('div', {
    staticClass: "user__company"
  }, [_c('h1', {
    staticClass: "user__company-name"
  }, [_c('span', {
    staticClass: "user__company-name--eng"
  }, [_vm._v(_vm._s(_vm.companyInfo.shortEngName))]), _vm._v(" "), _c('span', {
    staticClass: "user__company-name--chn"
  }, [_vm._v(_vm._s(_vm.companyInfo.shortChnName))])]), _vm._v(" "), _c('div', {
    staticClass: "user__company-info",
    domProps: {
      "innerHTML": _vm._s(_vm.companyInfo.aboutCompany)
    }
  })]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-303f60bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 1064
// module chunks = 1